import React from 'react';

export const SolarCheckCircle = (props) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.3332 16.4945C29.3332 23.8585 23.3638 29.8278 15.9998 29.8278C8.63584 29.8278 2.6665 23.8585 2.6665 16.4945C2.6665 9.13047 8.63584 3.16113 15.9998 3.16113C23.3638 3.16113 29.3332 9.13047 29.3332 16.4945ZM21.3732 12.4545C21.5604 12.642 21.6656 12.8961 21.6656 13.1611C21.6656 13.4261 21.5604 13.6803 21.3732 13.8678L14.7065 20.5345C14.519 20.7217 14.2648 20.8269 13.9998 20.8269C13.7348 20.8269 13.4807 20.7217 13.2932 20.5345L10.6265 17.8678C10.5283 17.7762 10.4495 17.6658 10.3948 17.5432C10.3401 17.4205 10.3108 17.2881 10.3084 17.1538C10.306 17.0196 10.3307 16.8862 10.381 16.7617C10.4313 16.6372 10.5062 16.524 10.6011 16.4291C10.6961 16.3341 10.8092 16.2593 10.9337 16.209C11.0582 16.1587 11.1916 16.134 11.3259 16.1363C11.4601 16.1387 11.5926 16.1681 11.7152 16.2228C11.8379 16.2774 11.9483 16.3562 12.0398 16.4545L13.9998 18.4145L16.9798 15.4345L19.9598 12.4545C20.1473 12.2672 20.4015 12.162 20.6665 12.162C20.9315 12.162 21.1857 12.2672 21.3732 12.4545Z"
      fill="currentColor"
    />
  </svg>
);
